module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/SammiDeco-988074ef071662ce395de940ee907240.png";